//// Country Dropdown Js ////
function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('weight-loss_lastQuestionafter', newValue);
}

function numberChange(lastNumber) {
    setCookie('weight-loss_lastNumber', lastNumber);
}

function findMedication(json, medicationName) {
    if (json.hasOwnProperty(medicationName)) {
      return json[medicationName];
    } else {
        return "Medication not found: " + medicationName;
    }
}

// function errorPopUp() {
//     $(".custom_error_popup").toggle();
// }

function preferredStrength(location,data) {
  $(location).html("");
   const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key, value]) => key && !(key === "skipStrength" && value === "false"))
  );
  $.each(filteredData, function(key, value) {
    const li = $("<li></li>");
    li.html(`
      <input type="checkbox" class="yes_btn" name="option" value="${key}">
      <label for="${key}">
        <div class="opction_btn_main">
          <div class="key_btn">
            <div class="key_helper">
              <div class="key_btn_content">
                <span class="key_helper_hint_text">Key</span><span class="key_helper_letter">${key.charAt(0)}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="checkbox_choice_content">
          <div class="text_textwrapper">${key}</div>
        </div>
        <div class="check_mark">
          <span class="icon-check">
            <i class="fal fa-check"></i>
          </span>
        </div>
      </label>
    `);
    $(location).append(li);
  });
  preferredStrengthClick();
}

function extractNoscriptData(htmlString) {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Find the noscript element
  const noscriptElement = tempDiv.querySelector('noscript.product_urls');
  if (!noscriptElement) {
    console.error('Noscript element not found');
    return;
  }

  // Get the JSON data from the noscript element
  const noscriptContent = noscriptElement.textContent.trim();
  let jsonData;
  try {
    jsonData = JSON.parse(noscriptContent);
  } catch (error) {
    console.error('Failed to parse JSON data from noscript:', error);
    return;
  }

  // Return the parsed JSON data
  return jsonData;
}

function findMedicationDosage(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}




function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}

$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});


$.getJSON('https://cdn.shopify.com/s/files/1/0425/4197/3660/files/custom-countries.json?v=1784870873', function(data) {
    $(".country_list").empty();
    data.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    $.each(data, function(index, item) {
        var html = `
            <div class="country_select_option">
                <div class="country_select_bg">
                    <div class="country_select_wrapper">
                        <span><img src="${item.flag}" alt="${item.name}" style="max-width:28px;"><div class="country_text">${item.name}</div></span>
                        <div class="select_contentText"><div class="country_code">${item.code}</div></div>
                    </div>
                </div>
            </div>
        `;
        $(".country_list").append(html);
    });
    $('.country_select_option').on("click", function () {
        var image = $(this).find("img").attr("src");
        var code = $(this).find(".country_code").text();
        var country = $(this).find(".country_text").text();
        $(".distribute .trigger-icon-button__StrokeIcon img").attr("src", image);
        $(".country_dropdown").removeClass("select_dropdown_show");
        $(".select_country_box input").attr("data-contry-code", code);
        $("#checkNumber").attr("data-contry-code", code);
        $(".form-selected-answer [data-handle='country-code']").val(code);
        $(".selected-country-name").text(country);
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-birthdata-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    
    if ($(this).val().length <= $limit) {
          
    } else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-question').each(function() {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
});

// $('.form-selected-answer').append('<input type="hidden" name="What is your BMI?" data-handle="what-is-your-bmi" value="">');
$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
// $('.form-selected-answer [data-handle="what-other-forms-of-id-do-you-have"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();
$('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').remove();


$('.form-selected-answer [data-handle="available-treatments"]').remove(); // dm-change 23 Nov ====
$('.form-selected-answer [data-handle="do-you-have-an-nhi"]').remove(); // dm-change ====
$('.form-selected-answer [data-handle="what-is-your-nhi"]').remove(); // dm-change ====
$('.form-selected-answer [data-handle="have-you-used-duromine-from-another-provider-in-the-last-4-weeks"]').remove(); // dm-change 09 jan 2024 ====
// $('.form-selected-answer [data-handle="we-require-a-full-body-shot-photo-of-you-either-standing-in-front-of-a-mirror-or-taken-by-someone-else-your-face-does-not-need-to-be-in-the-photo"]').remove();


$('.form-selected-answer [data-handle="have-you-taken-15mg-before"]').remove(); // dm-change | 11 Mar remove ====
$('.form-selected-answer [data-handle="have-you-taken-30mg-before"]').remove(); // dm-change | 11 Mar remove ====
$('.form-selected-answer [data-handle="have-you-taken-40mg-before"]').remove(); // dm-change | 11 Mar remove ====


$('.unfortunately_country_title .back_btn_content button,.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
  $('html, body').animate({
      scrollTop: 0
  }, 800);
  var cookieToDelete = 'weight-loss';
  deleteCookie(cookieToDelete);
  deleteCookie("weight-loss_lastQuestionafter");
  $('.form-selected-answer input[type="hidden"]').each(function(){
    $(this).val("");
  })
  $('.form-selected-answer').append('<input type="hidden" name="Which country do you live in? *" data-handle="which-country-do-you-live-in" value="AU">');
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('weight-loss_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('weight-loss_lastNumber');
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
        $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
  $('.form-selected-answer').append('<input type="hidden" name="Which country do you live in? *" data-handle="which-country-do-you-live-in" value="AU">');
});



var que1 = "would-you-best-describe-yourself-as-underweight-normal-weight-overweight-obese-or-superobese";
var que2 = "have-you-tried-anything-previously-for-weight-loss";
var que3 = "what-have-you-tried";
var que4 = "do-any-of-the-following-apply-to-you";
var que5 = "please-tell-us-more-about-the-condition-you-do-have";
var que6 = "are-you-taking-any-medications-including-over-the-counter-or-herbal-medicines-do-you-have-any-other-medical-condition-or-previous-operations-not-already-mentioned";
var que7 = "please-list-all-your-medications-you-take-and-any-other-medical-conditions-or-previous-operations";
// var que8 = "have-you-tried-weight-loss-pills";
var que8 = "have-you-tried-medical-weight-loss-treatments";
var que9 = "what-was-the-medication-what-dose-have-you-taken-before-did-the-medication-help-were-there-any-side-effects";
// var que10 = "what-is-your-bmi-body-mass-index";
var que10 = "please-enter-your-height-in-centimetres-and-weight-in-kilograms";
var que11 = "would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor";
var que12 = "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id";
var que13 = "please-enter-your-date-of-birth";
var que14 = "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment";
var que15 = "we-require-a-full-body-shot-photo-of-you-either-standing-in-front-of-a-mirror-or-taken-by-someone-else-your-face-does-not-need-to-be-in-the-photo";
var que16 = "address-proof";
var que17 = "appoinment";
var que18 = "which-country-do-you-live-in";

// new question add | 11 Mar start ===============
var que19 = "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead";
var que20 = "do-you-already-have-a-script";
var que21 = "please-paste-your-e-script-link-below";
var que22 = "enter-the-name-of-medication-below";
var que23 = "please-select-your-preferred-strength";
var que24 = "have-you-taken-15mg-before";
var que25 = "have-you-taken-30mg-before";
var que26 = "have-you-taken-40mg-before";
var que28 = "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues";
var que29 = "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues";
var que30 = "do-you-have-a-medication-preference";

// new question add | 11 Mar END ===============



$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var selfName = $(this).attr('name');
  var weightLossCookieValue = getCookie('weight-loss');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
        for (var i = 0; i < weightLossObjectItem.length; i++) {
          var currentObject = weightLossObjectItem[i];
          for (var key in currentObject) {
            if (currentObject.hasOwnProperty(key)) {
              var cookieValue = currentObject[key];
              // console.log(selfHandle,key,cookieValue,'cookieValue');
              if(key == selfHandle){
                $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
              }else{
                  if($('#callback-form input[data-handle="'+key+'"]').length == 0){
                    var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
                    var getQuestion = getName;
                    if(key == 'please-enter-your-sex-at-birth'){
                      getQuestion = 'Please enter your Sex At Birth';
                    }else if(key == 'please-enter-your-waist-circumference'){
                      getQuestion = 'Please enter your Waist Circumference';
                    }
                    $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
                    $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
                }
              }
            }
          }
       }
       if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
          if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
          }
       }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes'){
         if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
           var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
           $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
         }
       }

      if($('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'yes'){
          if($('#callback-form input[data-handle="do-you-have-an-nhi"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="Do you have an NHI?" data-handle="do-you-have-an-nhi">');
          }
       }

       if($('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'yes'){
          if($('#callback-form input[data-handle="what-is-your-nhi"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="What is your NHI?" data-handle="what-is-your-nhi">');
          }
       }

        
   }
});
var json;
function handleResponse() {
    const data = JSON.parse(this.responseText);
    const extractedData = extractNoscriptData(data['search-product-list-1']);
    json = extractedData;
    var medication = $('.form-selected-answer [data-handle=' + que22 + ']').val();
    var getData = findMedication(json, medication);
    preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData);
}

const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', 'https://bursthealth.com.au/pages/product-search-data?sections=search-product-list-1', true);
request.send();


//  Scountry selector

// $('.form_loop[data-question=' + que18 + '] .form_action_btn, .form_loop[data-question=' + que18 + '] input[type=checkbox]').click(function() {
//     ValidateRemove();
//     var $parent = $(this).parents('.form_loop'),
//         $this = $(this),
//         $currentNumber = parseInt($('.form_loop[data-question=' + que1 + ']').find('.number').html());
//     setTimeout(function() {
//         if ($parent.find('input[type=checkbox]:checked').length) {
//             var $value = $parent.find('input[type=checkbox]:checked').val();

//               if($value == "NZ") {
//                 // $(".form_loop[data-question=" + que14 + "] .select_country_box").find(".trigger-icon-button__StrokeIcon img").attr("src","https://flagcdn.com/nz.svg");
//                 // $(".form_loop[data-question=" + que14 + "] .select_country_box").find("input").attr("data-contry-code","+64");

//                 // $('.maintaining_option input[value=mounjaro]').parent('li').addClass('hide');
//                 // $('.maintaining_option input[value=ozempic]').parent('li').addClass('hide');

//                 // // $('.form-selected-answer').append('<input type="hidden" name="Available treatments" data-handle="available-treatments">');  // dm-change 23 nov === remove 01 Dec ====
//                 // $('.form-selected-answer').append('<input type="hidden" name="Do you have an NHI?" data-handle="do-you-have-an-nhi">');
//                 // $(".ihi_question .form_submit_btn").removeClass("hide_btn");
//                 // $(".ihi_question .form_next_btn").addClass("hide_btn");
                
//                 // $parent.removeClass('d-block').addClass('d-none');    // dm-change 11 Mar ================= 
//                 // $('.form_loop[data-question=' + que1 + ']').addClass('d-block'); 
//                 // var afterlastQuestion = $('.form_loop[data-question=' + que1 + ']').data("question");

//                 $parent.removeClass('d-block').addClass('d-none');
//                 $('.unfortunately_country_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                
//               }else if($value=='AU'){
//                 $(".ihi_question .form_submit_btn").addClass("hide_btn");
//                 $(".ihi_question .form_next_btn").removeClass("hide_btn");
//                 $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block');   // dm-change 11 Mar === 
//                 var afterlastQuestion = $parent.next().data("question");
                
//               }else{
//                 $('.maintaining_option input[value=mounjaro]').parent('li').removeClass('hide');
//                 $('.maintaining_option input[value=ozempic]').parent('li').removeClass('hide');
//               }

          
          
//                 $('.form-selected-answer [data-handle=' + que18 + ']').val($value);
//                 var newValue = { 'which-country-do-you-live-in': $value };
//                 pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber);
                

                
//                 CalculateP();
//         } else {
//             $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
//             shakeEffect($(this).parents('.form_loop'));
//         }
//     }, 100);
// });



// new question add | 11 Mar start ===============

if ($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'AU') {
  $(".ihi_question .form_submit_btn").addClass("hide_btn");
  $(".ihi_question .form_next_btn").removeClass("hide_btn");
}else {
  $(".ihi_question .form_submit_btn").removeClass("hide_btn");
  $(".ihi_question .form_next_btn").addClass("hide_btn");
}


$('.form_loop[data-question=' + que19 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que19 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            // $(".ihi_question .form_submit_btn").addClass("hide_btn");
            // $(".ihi_question .form_next_btn").removeClass("hide_btn");
            var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
            pushHistory($currentNumber + 1);
            CalculateP();
          }else {
            // $(".ihi_question .form_submit_btn").removeClass("hide_btn");
            // $(".ihi_question .form_next_btn").addClass("hide_btn");
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="would-you-best-describe-yourself-as-underweight-normal-weight-overweight-obese-or-superobese"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $('.form_loop[data-question="would-you-best-describe-yourself-as-underweight-normal-weight-overweight-obese-or-superobese"]').data("question");
          }
          
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});



function weightLossQestion() {
  $('.form_loop[data-question=' + que22 + '] .custom_select_button').click(function() {
      ValidateRemove();
      var $this = $(this),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        console.log(this,`$(".search-bar:not(.drawer) .predictive-search")$(".search-bar:not(.drawer) .predictive-search")`)
          $('.form-selected-answer [data-handle=' + que22 + ']').val($this.val());
          var medication = $this.val();
          var getData = findMedication(json, medication);
          var newValue = { 'enter-the-name-of-medication-below': $this.val()};
        
            if (getData.skipStrength == "true") {
              $('#callback-form').submit();
              var afterlastQuestion = "";
            } else {
              preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData)
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
            pushHistory($currentNumber + 1);
            CalculateP();
              pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
      }, 100);
  });
}
// $(".multi_search_section").each(function(){
//     if($(this).find("ul").html().trim() != ""){
//       $(".search-bar:not(.drawer) .predictive-search").html($(this).html());  
//     }
// })
setTimeout(()=>{
  weightLossQestion();
}, 3000);


function preferredStrengthClick() {
$('.form_loop[data-question=' + que23 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
      if ($parent.find('input[name=' + Name + ']:checked').length) {
          $('.form-selected-answer [data-handle=' + que23 + ']').val($this.val());

        if ($this.val() == '40 Mg') {
          $('.form-selected-answer').append('<input type="hidden" name="Have you taken 40mg before?" data-handle="have-you-taken-40mg-before">');          
          var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
        }else {
          $('#callback-form').submit();
        }
           var newValue = { 'please-select-your-preferred-strength': $this.val()};
              pushHistory($currentNumber + 1);
              CalculateP();
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
}
preferredStrengthClick();

$('.form_loop[data-question=' + que23 + '] .back_btn_content button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block').prev().addClass('d-block').find('.number').html($currentNumber - 1);
        pushHistory($currentNumber - 1);
        CalculateP();
      
    }, 100);
});

$('.form_loop[data-question=' + que26 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
      if ($parent.find('input[name=' + Name + ']:checked').length) {
         var newValue = { 'have-you-taken-40mg-before': $this.val()};
        $('.form-selected-answer [data-handle=' + que26 + ']').val($this.val());
        if ($this.val() == 'Yes') {
                $('#callback-form').submit();
                pushHistory($currentNumber + 1);
                CalculateP();
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title_que_40').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                var afterlastQuestion;
            }
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
$('.form_loop[data-question=' + que26 + '] .back_btn_content button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block').prev().addClass('d-block').find('.number').html($currentNumber - 1);
        pushHistory($currentNumber - 1);
        CalculateP();
      
    }, 100);
});

$('.form_loop[data-question=' + que28 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que28 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


$('.form_loop[data-question=' + que29 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + que29 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
        
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });
$('.form_loop[data-question=' + que30 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que30 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'do-you-have-a-medication-preference': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $('#callback-form').submit();
            var afterlastQuestion = "";
          }
          
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


// new question add | 11 Mar END ===============







//  STEP 1
$('.form_loop[data-question=' + que1 + '] .form_action_btn, .form_loop[data-question=' + que1 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            if ($value == "Underweight") {
                CalculateP();
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').not($('.unfortunately_title_only_back')).not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                $('.progress_content .progress_title span').html('100');
                $('#form_progress_bar').css('width', '100%');
            } else {

                $('.form-selected-answer [data-handle=' + que1 + ']').val($value);
                var newValue = { 'would-you-best-describe-yourself-as-underweight-normal-weight-overweight-obese-or-superobese': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('weight-loss', newValue, afterlastQuestion,$currentNumber + 1);              
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
            }
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

//  STEP 2
$('.form_loop[data-question=' + que2 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que2 + ']').val($this.val());
              var newValue = { 'have-you-tried-anything-previously-for-weight-loss': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 3
$('.form_loop[data-question=' + que3 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        var newValue = { 'what-have-you-tried': $value };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        $('.form-selected-answer [data-handle=' + que3 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 4
$('.form_loop[data-question=' + que4 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que4 + ']').val($this.val());
             var newValue = { 'do-any-of-the-following-apply-to-you': $this.val()};
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 5
$('.form_loop[data-question=' + que5 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que5 + ']').val($value);
         var newValue = { 'please-tell-us-more-about-the-condition-you-do-have': $value };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        setTimeout(function() {
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 6
$('.form_loop[data-question=' + que6 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que6 + ']').val($this.val());
          var newValue = { 'are-you-taking-any-medications-including-over-the-counter-or-herbal-medicines-do-you-have-any-other-medical-condition-or-previous-operations-not-already-mentioned': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion =  $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 7
$('.form_loop[data-question=' + que7 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que7 + ']').val($value);
        var newValue = { 'please-list-all-your-medications-you-take-and-any-other-medical-conditions-or-previous-operations': $value };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          console.log($currentNumber + 1,$value,'$value');
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 8
$('.form_loop[data-question=' + que8 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que8 + ']').val($this.val());
            var newValue = { 'have-you-tried-weight-loss-pills': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
            if($('#callback-form input[data-handle="do-you-have-hypertension-or-take-antidepressant-medication"]').val() == 'Yes' && $('#callback-form input[data-handle="have-you-tried-medical-weight-loss-treatments"]').val() == 'Yes' || $('#callback-form input[data-handle="have-you-tried-medical-weight-loss-treatments"]').val() == 'Yes' || $('#callback-form input[data-handle="do-you-have-hypertension-or-take-antidepressant-medication"]').val() == 'No' && $('#callback-form input[data-handle="have-you-tried-medical-weight-loss-treatments"]').val() == 'No'){
              $('.maintaining_option input[value=duromine]').parent('li').removeClass('hide').next().find('.key_helper_letter').html('F');
            }else{
              $('.maintaining_option input[value=duromine]').parent('li').addClass('hide');
            }
        }
    }, 100);
});

// STEP 9
$('.form_loop[data-question=' + que9 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que9 + ']').val($value);
          var newValue = { 'what-was-the-medication-what-dose-have-you-taken-before-did-the-medication-help-were-there-any-side-effects': $value };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 10
$('.form_loop[data-question=' + que10 + '] button').click(function() {
    const BMIHeight = $('#BMIForm-height').val();
    const BMIWeight = $('#BMIForm-weight').val();
    var BMI;
    if (BMIHeight != "" && BMIWeight != "") {
      
      const BMII = (BMIWeight / BMIHeight ** 2) * 10000;
      BMI = BMII.toFixed(2);
      $('.bmi-value').val(BMI);
      $('.form-selected-answer [data-handle="what-is-your-bmi"]').val(BMI);
      //   setTimeout(function(){
      //     $('.bmi-que-ans .ok_btn_content button').trigger('click');
      //   },100);	
    }

    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      var $value;
      if ($parent.find('.bmi-value').val() != ""){      
        var $value = $parent.find('.bmi-value').val(),
            $value = $value.trim(),
            $value = parseFloat($value);
      }

    if ($value != undefined) {
        var get_country_type = $('.form-selected-answer [data-handle=' + que18 + ']').val(); 
        
        if ($value >= 30) {
              $('.form-selected-answer [data-handle=' + que10 + ']').val(BMIHeight + ' - ' + BMIWeight);
          
              if ($('.form-selected-answer [data-handle=what-is-your-bmi-body-mass-index]').length == 0) {
                  $('<input type="hidden" name="What is your BMI (body mass index)? *" data-handle="what-is-your-bmi-body-mass-index">').insertAfter('.form-selected-answer [data-handle=' + que10 + ']');
                  $('.form-selected-answer [data-handle=what-is-your-bmi-body-mass-index]').val($value);
                  // var newValue = { 'what-is-your-bmi-body-mass-index': $value };
                  // pushValueToCookieArray('weight-loss', newValue, $currentNumber + 1 );
            
              }
              setTimeout(function() {
                  if(get_country_type=='NZ'){
                    $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                    $('.goverment_legal_id_name').addClass('d-block').removeClass('d-none');
                    var afterlastQuestion = $('.goverment_legal_id_name').data("question");
                    $('.goverment_legal_id_name').find('.number').html($currentNumber + 1);
                  }else{
                    if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
                      $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                      $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').addClass('d-block').find('.number').html($currentNumber + 1);
                      var afterlastQuestion = $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').data("question");
                    }else{
                      $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                      var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                    }
                  }
                  console.log($currentNumber + 1,'123')
                //   var newValue = { 'please-enter-your-height-in-centimetres-and-weight-in-kilograms': BMIHeight + ' height - ' + BMIWeight + ' weight' };
                  var newValue = { 'please-enter-your-height-in-centimetres-and-weight-in-kilograms': BMIHeight + ' - ' + BMIWeight };
                  pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          
                  
                  pushHistory($currentNumber + 1);
                  CalculateP();
              }, 100);
          } else {
              CalculateP();
              // if(get_country_type=='NZ'){     // dm-chnages 12 Dec
                // $this.parents('.form_loop').addClass('d-none').removeClass('d-block');   
                // $('.goverment_legal_id_name').addClass('d-block').removeClass('d-none');
              // }else{
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').not($('.unfortunately_title_only_back')).not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              // }
              
              $('.progress_content .progress_title span').html('100');
              $('#form_progress_bar').css('width', '100%');
          }
        
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('.calculator_data'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }

});

// STEP 11
$('.form_loop[data-question=' + que11 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que11 + ']').val($this.val());
          
            var newValue = { 'would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor': $this.val() };
          
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.book-consiltation-doctor').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                pushHistory($currentNumber + 1);
                CalculateP();
            }
        }
    }, 100);
});

// STEP 12
$('.form_loop[data-question=' + que12 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que12 + ']').val($value);
          setTimeout(function() {
            if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
              $('.form_loop[data-question="please-enter-your-date-of-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $('.form_loop[data-question="please-enter-your-date-of-birth"]').data("question");
            }else { 
              var afterlastQuestion = $parent.next().data("question");
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            }
      
              pushHistory($currentNumber + 1);
              CalculateP();
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 13
$('.form_loop[data-question=' + que13 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val();

    var InputDate = new Date($MM + '/' + $DD + '/' + $YY);
    var Today = new Date();
    var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());

    var Difference_In_Time = Today.getTime() - InputDate.getTime();

    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    if (Difference_In_Days >= 18 && ($MM.length <= 2 && $DD.length <= 2 && $YY.length == 4)) {
        $('.form-selected-answer [data-handle=' + que13 + ']').val($DD + '/' + $MM + '/' + $YY);

      if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
        $(this).parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="please-enter-your-height-in-centimetres-and-weight-in-kilograms"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="please-enter-your-height-in-centimetres-and-weight-in-kilograms"]').data("question");
      }else {
        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
      }
          var newValue = { 'please-enter-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        pushHistory($currentNumber + 1);
      
        CalculateP();
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 14
$('.form_loop[data-question=' + que14 + '] .form_next_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop');

    var mobile_number_length = 9;
    var get_country_type = $('.form-selected-answer [data-handle=' + que18 + ']').val(); 
    if(get_country_type=='NZ'){
      mobile_number_length = 8;
    }
  
    if ($parent.find('.select_country_box input').val().length > mobile_number_length) {
        $this.attr('disabled', 'disabled');
        var Value = $parent.find('.select_country_box input').val(),
            Ccode = $parent.find('.select_country_box input').data('contry-code');
        var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());
        

        // $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form-selected-answer [data-handle=country-code]').val(Ccode);
        $('#checkNumber').val(Value); 
      
        if($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'NZ'){
          $('.form-selected-answer [data-handle=' + que14 + ']').val(Value);
          // $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block');
          $('.form_loop[data-question=' + que14 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1)
          pushHistory($currentNumber + 1);
          var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': Value };
          var afterlastQuestion = $('.form_loop[data-question=' + que14 + '] button').parents('.form_loop').next().next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
        } else { 
          $('#confirmation_popup').toggle();
        }
      
        CalculateP();
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }

});


function otpAfterClick() {
$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   var $currentNumber = parseInt($('.form_loop[data-question=' + que14 + ']').find('.number').html());
  
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();
    $('.form-selected-answer [data-handle=' + que14 + ']').val(checkVal);
    $('.form_loop[data-question=' + que14 + '] button').find('input').val(checkVal);
     
     if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
        $('.form_loop[data-question=' + que14 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block')
        $('.form_loop[data-question="do-you-have-a-medicare-card"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medicare-card"]').data("question");
     }else{
        $('.form_loop[data-question=' + que14 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);       
        var afterlastQuestion = $('.form_loop[data-question=' + que14 + '] button').parents('.form_loop').next().next().data("question");
     }
     
     var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': checkVal };
     pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);


   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})
}
otpAfterClick()
// $('.custom_error_popup .confirm_button').click(function(){
//     $('.custom_error_popup').toggle();
// })


// STEP 15
$('.form_loop[data-question=' + que15 + '] .form_next_btn button').click(function() {
    console.log('1111');
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop');
    if ($parent.find('.Customer_details_content input.profile_url_hidden').val() != '') {
        $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block');
        var urlval = $parent.find('.Customer_details_content input.profile_url_hidden').val();
        $('.form-selected-answer [data-handle=' + que15 + ']').val(urlval);

      var newValue = { 'we-require-a-full-body-shot-photo-of-you-either-standing-in-front-of-a-mirror-or-taken-by-someone-else-your-face-does-not-need-to-be-in-the-photo': urlval };
      var afterlastQuestion = $parent.next().data("question");
      pushValueToCookieArray('weight-loss', newValue, afterlastQuestion);
      
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// ?

$('.form_loop[data-question="please-provide-your-sex-at-birth-and-waist-circumference-in-centimetres"] .ok_btn_content button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $selectValue = $parent.find('input[type=checkbox]:checked').val(),
        $value = $parent.find('#waist_circumference').val();
    if ($value != '' && $parent.find('input[type=checkbox]:checked').length) {

        var targets = $this.parents('.form_loop').addClass('d-none').removeClass('d-block');

        if ($('.form-selected-answer input[name="Please enter your Sex At Birth"]').length && $('.form-selected-answer input[name="Please enter your Waist Circumference"]').length) {

        } else {
            $('.form-selected-answer').append('<input type="hidden" name="Please enter your Sex At Birth" data-handle="please-enter-your-sex-at-birth">');
            $('.form-selected-answer').append('<input type="hidden" name="Please enter your Waist Circumference" data-handle="please-enter-your-waist-circumference">');
        }
        $('.form-selected-answer [data-handle="please-enter-your-sex-at-birth"]').val($selectValue);
        $('.form-selected-answer [data-handle="please-enter-your-waist-circumference"]').val($value);

        var newValue = { 'please-enter-your-sex-at-birth': $selectValue };
                pushValueToCookieArray('weight-loss', newValue);
        

        if ($selectValue == 'Male' || $selectValue == 'male') {
            if ($value >= 102) {
                if ($('#callback-form input[data-handle="available-treatments"]').val() == 'duromine') {
                    targets.next().addClass('d-block');
                      
                } else {
                  // dm-changes =====
                  if($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'NZ'){
                    $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').addClass('d-block');
                    var afterlastQuestion = $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').data("question");
                  }else {
                    $('.form_loop[data-question="do-you-have-a-medicare-card"]').addClass('d-block');
                    var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medicare-card"]').data("question");
                  }
                }
            } else {
                $('.unfortunately_title').not($('.unfortunately_title_only_back')).not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
            }
        } else {
            if ($value >= 88) {
                if ($('#callback-form input[data-handle="available-treatments"]').val() == 'duromine') {
                    targets.next().addClass('d-block');
                } else {
                    // dm-changes =====
                  if($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'NZ'){
                    $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').addClass('d-block');
                    var afterlastQuestion = $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').data("question");
                  }else {
                    $('.form_loop[data-question="do-you-have-a-medicare-card"]').addClass('d-block');
                    var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medicare-card"]').data("question");
                  }
                }
            } else {
                $('.unfortunately_title').not($('.unfortunately_title_only_back')).not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
            }
        }
              var newValue = { 'please-enter-your-waist-circumference': $value };
              pushValueToCookieArray('weight-loss', newValue,afterlastQuestion);

    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});


$('.form_loop[data-question="do-you-have-hypertension-or-take-antidepressant-medication"] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $value = $parent.find('input[type=checkbox]:checked').val(),
        $currentNumber = parseInt($parent.find('.number').html());
    getValFromQueSix = $value;
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle="do-you-have-hypertension-or-take-antidepressant-medication"]').val($this.val());

          var newValue = { 'do-you-have-hypertension-or-take-antidepressant-medication': $this.val() };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          console.log($currentNumber + 1,$value,'$value');
          $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
          
          
            $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block');
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});


// STEP ??
$('.form_loop[data-question="available-treatments"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val(),
                $URL = $parent.find('input[type=checkbox]:checked').attr('data-url');

            $('.form-selected-answer [data-handle="available-treatments"]').val($value);
            $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);

          var newValue = { 'available-treatments': $value };
          var afterlastQuestion = $parent.next().data("question");
          pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();

        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// ???
$('.form_loop[data-question="have-you-used-duromine-from-another-provider-in-the-last-4-weeks"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

          
            if ($value == "yes") {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').not($('.unfortunately_title_only_back')).not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
            } else {
              if($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'NZ'){
                $parent.addClass('d-none').removeClass('d-block'); // new dm-changes
                var afterlastQuestion =  $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').data("question");
                $('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').addClass('d-block');
              }else {
                var afterlastQuestion = $parent.next().data("question");
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              }
              var newValue = { 'have-you-used-duromine-from-another-provider-in-the-last-4-weeks': $value };
              pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
            }

            $('.form-selected-answer [data-handle="have-you-used-duromine-from-another-provider-in-the-last-4-weeks"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP ????
$('.form_loop[data-question="do-you-have-a-medicare-card"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'do-you-have-a-medicare-card': $value };

            if ($value == "yes") {
                // $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $parent.removeClass('d-block').addClass('d-none');
                $('.ans_for_yes').addClass('d-block').find('.number').html($currentNumber + 1);

                var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
                    cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
                    monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';

                $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
                $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
                var afterlastQuestion = $('.ans_for_yes').data("question");

            } else {
                //         $('.form-selected-answer').append('<input type="hidden" name="What other forms of ID do you have" data-handle="what-other-forms-of-id-do-you-have">');
                $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
                $parent.removeClass('d-block').addClass('d-none');
                $('.ans_for_no').addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $('.ans_for_no').data("question");
            }
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          
            $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP dm-changes =====
$('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

              var newValue = { 'do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication': $value };
          
            if ($value == "Yes") {
                $('.form_loop[data-question="do-you-have-an-nhi"]').addClass('d-block');
              if($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'NZ'){
                $parent.addClass('d-none').removeClass('d-block'); // new dm-changes
              }else {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
              }
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title_only_back').not($('.unfortunately_title_que_40,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
            }
          
            $('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP dm-changes =====
$('.form_loop[data-question="do-you-have-an-nhi"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            if ($value == "Yes") {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $('.form-selected-answer').append('<input type="hidden" name="What is your NHI?" data-handle="what-is-your-nhi">');
            } else {
               // $parent.addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
              // $parent.addClass('d-none').removeClass('d-block');
              // $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
              // $('.ans_for_no[data-question="what-is-your-ihi"]').addClass('d-block').find('.number').html($currentNumber + 1);
              $('#callback-form').submit();
            }


            var newValue = { 'do-you-have-an-nhi': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('weight-loss', newValue, afterlastQuestion, $currentNumber + 1);
          
            $('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP dm-changes
$('.form_loop[data-question="what-is-your-nhi"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();


        var newValue = { 'what-is-your-nhi': $value };
        pushValueToCookieArray('weight-loss', newValue, $currentNumber + 1);
  
    if ($value.length) {
        $('.form-selected-answer [data-handle="what-is-your-nhi"]').val($value);
        setTimeout(function() {
            // $parent.addClass('d-none').removeClass('d-block');
            // $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
            // $('.ans_for_no[data-question="what-is-your-ihi"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
          $('#callback-form').submit();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 16
$('.form_loop[data-question="please-enter-your-medicare-card-details"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());

    var $MM = $('.card_years_field .month input').val(),
        $YY = $('.card_years_field .year input').val(),
        $INR = $parent.find('.details_filed input.enter_irn_number').val(),
        $CardNumber = $parent.find('.details_filed input.enter_card_number').val();

    if ($parent.find('.details_filed input.enter_irn_number').val().length == 1 && $parent.find('.details_filed input.enter_card_number').val().length == 10 && $MM <= 12 && $MM != '' && $YY != '') {
      
        $('.neurological_que[data-question="appoinment"]').addClass('d-block');
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_irn"]').val($INR);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_number"]').val($CardNumber);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_month_year"]').val(`${$MM}/${$YY}`);

        // if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
        // }
        if ($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'AU') {
          var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
        }
      
        var newValue = { 'do-you-have-a-medicare-card_irn': $INR };
                    pushValueToCookieArray('weight-loss', newValue,afterlastQuestion);
  
        var newValue = { 'do-you-have-a-medicare-card_number': $CardNumber };
                    pushValueToCookieArray('weight-loss', newValue,afterlastQuestion);
  
        var newValue = { 'do-you-have-a-medicare-card_month_year': $MM+ "/" +$YY };
                    pushValueToCookieArray('weight-loss', newValue,afterlastQuestion, $currentNumber + 1);

      // if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
      if ($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'AU') {
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
      }else { 
        $parent.addClass('d-none').removeClass('d-block');
        var afterlastQuestion = "";
          $('#callback-form').submit();
      }
  
  
        
          CalculateP();
    
    } else {
        shakeEffect($parent);
        // errorPopUp();
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// $('.form_loop[data-question="what-other-forms-of-id-do-you-have"] .form_submit_btn button').click(function(){
//   ValidateRemove();
//   var $this = $(this),
//       $parent = $this.parents('.form_loop'),
//       $currentNumber = parseInt($parent.find('.number').html()),
//       $value = $parent.find('.details_filed input').val();
//   if ($value != ''){
//     $parent.addClass('d-none').removeClass('d-block');
//     $('.neurological_que[data-question="appoinment"]').addClass('d-block').find('.number').html($currentNumber+1);
//     pushHistory($currentNumber+1);
//     CalculateP();
//     $('.form-selected-answer [data-handle="what-other-forms-of-id-do-you-have"]').val($value);
//     $('#callback-form').submit();
//   }
//   else {
//     shakeEffect($parent);
//     $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
//     setTimeout(function(){ $('.valid_date_text').remove(); },2500);
//   }
// });


$('.form_loop[data-question="what-is-your-ihi"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('.details_filed input').val();
    if ($value != '') {
      
        // if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
        if ($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'AU') {
          var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
        }
      
        var newValue = { 'what-is-your-ihi': $value };
        pushValueToCookieArray('weight-loss', newValue,afterlastQuestion, $currentNumber + 1);
        $('.form-selected-answer [data-handle="what-is-your-ihi"]').val($value);
      
        // if ($('.form-selected-answer [data-handle=' + que19 + ']').val() == 'Yes') {
        if ($('.form-selected-answer [data-handle=' + que18 + ']').val() == 'AU') {
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
          $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
        }else { 
          $parent.addClass('d-none').removeClass('d-block');
          $('.neurological_que[data-question="appoinment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = "";
          $('#callback-form').submit();
        }
      
        pushHistory($currentNumber + 1);
        CalculateP();

      
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});


// STEP 17
// $('.form_loop .form_submit_btn button').click(function(){
//   ValidateRemove();
//   var $this = $(this),
//       $parent = $this.parents('.form_loop');
//   if ($parent.find('.Customer_details_content select').val() != ''){
//     $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block');
//     CalculateP();
//     $('#callback-form').submit();
//   }
//   else {
//     shakeEffect($parent);
//     $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
//     setTimeout(function(){ $('.valid_date_text').remove(); },2500);
//   }
// });



var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', {
        eventCategory: 'weight-loss',
        eventAction: 'Submit',
        eventLabel: 'Weight loss form',
        eventValue: 1
    });

  $Form.find("input[type='hidden']").each(function() {
    var get_data_handle = $(this).attr('data-handle');

    if(get_data_handle=='please-enter-your-medicare-card-details'){
        if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
          if($(this).val() == ""){
            $(this).remove();
          }    
        }
    }else{
      if($(this).val() == ""){
        $(this).remove();
      }
    }
    
  })

    var country_selected = $('.form-selected-answer [data-handle=' + que18 + ']').val();
    if(country_selected == 'NZ'){
        // localStorage.setItem('weightloss_form', true);
        var redirectionMainUrl = 'https://bursthealth.co.nz/products/duromine-or-phentermine-weight-loss-program-starting-at-4-39-a-day-nz';
    }else {
      if ($('.form-selected-answer [data-handle=' + que30 + ']').val() == 'No') {
        // localStorage.setItem('weightloss_form', true);
        var redirectionMainUrl = json['do-you-have-a-medication-preference-weight-loss'];
      }else{
        var medicationO = $('.form-selected-answer [data-handle=' + que22 + ']').val();
        var getDataO = findMedication(json, medicationO);
        
        if (getDataO.skipStrength == "true") {
          
          // localStorage.setItem('weightloss_form', true);
          var redirectionMainUrl = getDataO.skipDirectUrl;
          
        }else {
        
          const medication = $('.form-selected-answer [data-handle=' + que22 + ']').val();
          const dosage = $('.form-selected-answer [data-handle=' + que23 + ']').val();
          var getData = findMedicationDosage(json, medication, dosage);
          // localStorage.setItem('weightloss_form', true);
          var redirectionMainUrl = getData.url;
        }
      }
    }
  
    var noscriptContent = $('#productString_url').html();
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urls = noscriptContent.match(urlRegex);

    
    $('.form-selected-answer').append(`<input type="hidden" name="Product redirection Url" value="${redirectionMainUrl}">`);
    $('.form-selected-answer').append(`<input type="hidden" name="Product Session id" value="${unique_id}">`);
    $.each(urls, function(index, url) {
     if (url.includes(redirectionMainUrl) || redirectionMainUrl.includes(url)) {
      $('.form-selected-answer').append(`<input type="hidden" name="Product String Url" value="true">`);
     }
    });

  setTimeout(() => {
    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);

            console.log(data, '---987456');
            // jQuery.post('/cart/update.js', "attributes[weightloss-uid]=" + data.unique_id);
            // setCookie("weightloss-uid", data.unique_id, 30);
            // var doctor_recommand = data.doctor_recommand;

            var cookieToDelete = 'weight-loss';
            deleteCookie(cookieToDelete);
            deleteCookie("weight-loss_lastQuestionafter");

            setTimeout(function() {
                // var country_selected = $('.form-selected-answer [data-handle=' + que18 + ']').val();
                // if (doctor_recommand != undefined) {
                //     if(doctor_recommand == 'contrave' && country_selected=='NZ'){
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.co.nz/products/contrave-naltrexone-bupropion-weight-loss-treatment-plan-nz";
                //     }else if (doctor_recommand == 'contrave') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.com.au/products/contrave-weight-loss-treatment-plan";
                //     } else if (doctor_recommand == 'ozempic') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.com.au/products/ozempic-weight-loss-treatment-program";
                //     } else if (doctor_recommand == 'saxenda' && country_selected=='NZ') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.co.nz/products/saxenda-liraglutide-6mg-weight-loss-injections-nz";
                //     }else if (doctor_recommand == 'saxenda') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.com.au/products/saxenda-weight-loss-injections";
                //     } else if (doctor_recommand == 'xenical' && country_selected=='NZ') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.co.nz/products/xenical-orlistat-84-capsules-medication-for-weight-loss-nz";
                //     }  else if (doctor_recommand == 'xenical') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = " https://bursthealth.com.au/products/xenical-weight-loss-capsules";
                //     } else if (doctor_recommand == 'shakes') {
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = " https://bursthealth.com.au/products/tastyslimshakes";
                //     } else if (doctor_recommand == 'mounjaro') {                                  
                //         // localStorage.setItem('weightloss_form', false);
                //         location.href = "https://bursthealth.com.au/products/mounjaro-reconstituted";
                //     } else if (doctor_recommand == 'duromine' && country_selected=='NZ') {
                //         // localStorage.setItem('weightloss_form', true);
                //         location.href = 'https://bursthealth.co.nz/products/duromine-or-phentermine-weight-loss-program-starting-at-4-39-a-day-nz';
                //     } else if (doctor_recommand == 'duromine') {
                //         // localStorage.setItem('weightloss_form', true);
                //         if ($('.form-selected-answer [data-handle="do-you-have-hypertension-or-take-antidepressant-medication"]').val() == 'Yes') {
                //             location.href = 'https://bursthealth.com.au/products/duromine-phentermine15mg';
                //         } else {
                //             if ($('.form-selected-answer [data-handle=' + que8 + ']').val() == 'No') {
                //                 console.log('if-in-no');
                //                 location.href = 'https://bursthealth.com.au/products/copy-of-duromine-phentermine-weight-loss-program-starting-at-4-39-a-day-non40';
                //             } else {
                //                 console.log('else-in-no');
                //                 location.href = 'https://bursthealth.com.au/products/duromine-phentermine-weight-loss-program-starting-at-4-39-a-day-brands';
                //             }
                //         }
                //     }
                // } else {
                //     // location.href = redirectionMainUrl;
                // }
                  location.href = data.product_link;
            }, 1000);
        },
        error: function() {
          console.log('is erroreeeeeeeeeeeee')
            if ($('.form-selected-answer [data-handle=' + que8 + ']').val() == 'No') {
                location.href = 'https://bursthealth.com.au/products/copy-of-duromine-phentermine-weight-loss-program-starting-at-4-39-a-day-non40';
            } else {
                location.href = 'https://bursthealth.com.au/products/duromine-phentermine-weight-loss-program-starting-at-4-39-a-day-brands';
            }
        }
    });
  },500);
});



function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function fillvalue(question) {
    if ($('.form-selected-answer [data-handle=' + question + ']').val() == '') {
        $('.form-selected-answer [data-handle=' + question + ']').val('No response');
    }
}

if (location.pathname == '/pages/weight-loss-questionnaire-verification') {
    window.history.pushState("", "", location.pathname);
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

function togglePopup() {
  $("#popup_message").toggle();
}

$('#book_appoinment').change(function() {
    if ($(this).val() == '9:00 to 5:00') {
        $('.customer_details_time_section').toggle();
    }
});




// Profile Upload

var video1 = document.querySelector("#videoElement");
$('#enable_camera_profile').click(function() {
    if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
                video: true
            })
            .then(function(stream) {
                window.localStream = stream;
                video1.srcObject = stream;
                $('#videoElement').show();
                //         $('#snap_profile').show();
                $('#enable_camera_profile').hide();
                $('#profile_normal_image').hide();
              $('#profile_normal_image_desktop').hide();
                $('#profile_blah').hide();
                $('#use_photo').show();
                $('#use_photo').attr('disabled', 'disabled');
                run_timer();

            })
            .catch(function(err0r) {
                alert('Web cam not detected');
            });

    }
});




$('#retake_profile').click(function() {


    if (navigator.mediaDevices.getUserMedia) {
        $('#videoElement').hide();
        navigator.mediaDevices.getUserMedia({
                video: true
            })
            .then(function(stream) {
                window.localStream = stream;
                video1.srcObject = stream;
                $('#use_photo').show();
                $('#retake_profile').hide();
                $('#videoElement').show();
                $('.Profile_Canvas').hide();
                //         $('#snap_profile').show();
                $('#enable_camera_profile').hide();
                $('#profile_normal_image').hide();
              $('#profile_normal_image_desktop').hide();
                $('#profile_blah').hide();
                $('#use_photo').removeAttr('hidden');
                $('#use_photo').attr('disabled', 'disabled');
                run_timer();
            })
            .catch(function(err0r) {
                alert('Web cam not detected');
            });
    }
});


function run_timer() {
    var timeleft = 10;
    var downloadTimer = setInterval(function() {

        document.getElementById("use_photo").innerHTML = timeleft;
        if (timeleft <= 0) {
            clearInterval(downloadTimer);
            snaps();
            $('#use_photo').html('Use Photo');
            $('#use_photo').removeAttr('disabled');
            $('#retake_proof').show();
        }
        timeleft -= 1;
    }, 1000);
}


var video = document.querySelector('.question_video');
var canvas2 = document.querySelector('.Profile_Canvas');
var context = canvas2.getContext('2d');
var w, h, ratio;


video.addEventListener('loadedmetadata', function() {
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = parseInt(w / ratio, 10);
    canvas2.width = w;
    canvas2.height = h;
    //       canvas2.width = 200;
    //       canvas2.height = 200;
}, false);

function snaps() {
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);

    var canvas_img_data1 = canvas2.toDataURL('image/png');
    var img_data1 = canvas_img_data1.replace(/^data:image\/(png|jpg);base64,/, "");
    $('#Profile_ScreenshotImage').html(img_data1);
    $('#profile_file_type').val('screenshot');
    $('.Profile_Canvas').show();
    $('#videoElement').hide();
    $('#retake_profile').show();
    $('#snap_profile').hide();
    localStream.getVideoTracks()[0].stop();
    $('#Profile_Upload').val('');
    $('#Submit_Profile_btn').removeAttr('disabled');
    $('#Submit_Profile_btn').html('Upload');
    $('#profile_normal_image').hide();
  $('#profile_normal_image_desktop').hide();
    $('#profile_blah').hide();
    //       	upload_image('profile');
}


$('#use_photo').click(function() {
    upload_image('profile');
    $('#retake_profile').hide();
    $('#use_photo').hide();
    $('#please_wait_btn').show();
});


Profile_Upload.onchange = evt => {
    const [file] = Profile_Upload.files
    if (file) {
        console.log(file.size);
        //     if(file.size < 3145728){
        profile_blah.src = URL.createObjectURL(file)

        $('#profile_file_type').val('upload_file');
        $('.Profile_Canvas').hide();
        //       $('#enable_camera_profile').show();
        $('#videoElement').hide();
        $('#retake_profile').hide();
        $('#snap_profile').hide();
        $('#Profile_ScreenshotImage').val('');
        $('#Submit_Profile_btn').removeAttr('disabled');
        $('#Submit_Profile_btn').html('Upload');

        $('#profile_normal_image').hide();
      $('#profile_normal_image_desktop').hide();
        $('#profile_blah').show();
        upload_image('profile');
        //     }else{
        //     	alert('upload file upto 3mb');
        //     }
    }
}

// $('#Profile_Upload').change(function(){


// });

$('#upload_profile').click(function() {
    $('#Profile_Upload').click();
    var get_country_type = $('.form-selected-answer [data-handle=' + que18 + ']').val(); 
      if(get_country_type=='AU'){
         $('.form-selected-answer').append('<input type="hidden" name="Do you have a Medicare card?" data-handle="do-you-have-a-medicare-card">')                        
      }
});

$('#upload_profile_address').click(function() {
    $('#address_Profile_Upload').click();
});



// Proof Upload
var video2 = document.querySelector("#proof_videoElement");
$('#enable_camera_proof').click(function() {
    if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
                video: true
            })
            .then(function(stream) {
                window.localStream = stream;
                video2.srcObject = stream;
                $('#proof_videoElement').show();
                $('#snap_proof').show();
                //         $('#enable_camera_profile').hide();
                $('#proof_normal_image').hide();
                $('#proof_blah').hide();
            })
            .catch(function(err0r) {
                alert('Web cam not detected');
            });

    }
});



$('#retake_proof').click(function() {
    if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
                video: true
            })
            .then(function(stream) {
                window.localStream = stream;
                video1.srcObject = stream;
                $('#snap_proof').show();
                $('.proof_Canvas').hide();
                $('#proof_videoElement').show();
                $('#retake_proof').hide();
                $('#proof_normal_image').hide();
                $('#proof_blah').hide();
            })
            .catch(function(err0r) {
                alert('Web cam not detected');
            });
    }
});


var video2 = document.querySelector('.proof_question_video');
var canvas3 = document.querySelector('.proof_Canvas');
var context3 = canvas3?.getContext('2d');
var w, h, ratio;


video2.addEventListener('loadedmetadata', function() {
    ratio = video2.videoWidth / video2.videoHeight;
    w = video2.videoWidth - 100;
    h = parseInt(w / ratio, 10);
    canvas3.width = w;
    canvas3.height = h;
    //       canvas2.width = 200;
    //       canvas2.height = 200;
}, false);

function snaps_proof() {
    context3.fillRect(0, 0, w, h);
    context3.drawImage(video2, 0, 0, w, h);

    var canvas_img_data1 = canvas3.toDataURL('image/png');
    var img_data1 = canvas_img_data1.replace(/^data:image\/(png|jpg);base64,/, "");
    $('#Proof_ScreenshotImage').html(img_data1);
    $('#proof_file_type').val('screenshot');
    $('.proof_Canvas').show();
    $('#proof_videoElement').hide();
    $('#retake_proof').show();
    $('#snap_proof').hide();
    localStream.getVideoTracks()[0].stop();
    $('#Proof_Upload').val('');
    $('#proof_normal_image').hide();
    $('#proof_blah').hide();
    upload_image('proof');
}



Proof_Upload.onchange = evt => {
    const [file] = Proof_Upload.files
    if (file) {
        proof_blah.src = URL.createObjectURL(file)
    }
}

$('#Proof_Upload').change(function() {
    $('#proof_file_type').val('upload_file');
    $('.proof_Canvas').hide();
    $('#enable_camera_proof').show();
    $('#proof_videoElement').hide();
    $('#retake_proof').hide();
    $('#snap_proof').hide();
    $('#Proof_ScreenshotImage').val('');

    $('#proof_normal_image').hide();
    $('#proof_blah').show();
    upload_image('proof');
});

$('#upload_proof').click(function() {
    $('#Proof_Upload').click();
});




function upload_image(type) {

    var url = 'https://bursthealthcare.com/api/upload_image_cloud';

    if (type == 'profile') {
        var file_type = $('#profile_file_type').val();
        if (file_type == 'upload_file' || file_type == 'screenshot') {
            var file_data = $('#Profile_Upload').prop('files')[0];
            //       if(file_data.size > 3145728){
            //       	alert('file size upload 3mb');
            //         return;
            //       }
            var textareaval = $('#Profile_ScreenshotImage').val();
            var formDataToUpload = new FormData();
            formDataToUpload.append('file', file_data);
            formDataToUpload.append('screenshot', textareaval);
            formDataToUpload.append('file_type', file_type);
            formDataToUpload.append('type', type);
          formDataToUpload.append('que_type', 'weight_loss');

            $.ajax({
                url: url,
                type: "POST",
                contentType: false,
                processData: false,
                data: formDataToUpload,
                beforeSend: function() {
                    $('#upload_profile').attr('disabled', 'disabled');
                    $('#upload_profile').html('Please wait..');
                },
                success: function(result) {
                    var result = JSON.parse(result);
                    if (result.error_status != '') {
                        alert(result.error_status);
                        $('#upload_profile').html('Select Photo');
                        $('#upload_profile').removeAttr('disabled');
                    } else {
                        if (result.url != null) {
                            $('.profile_url_hidden').val(result.url);
                            $('.form-selected-answer [data-handle=' + que15 + ']').val(result.url);
                            $('#upload_profile').html('Done');
                            if ($('#callback-form input[data-handle="available-treatments"]').val() == 'duromine') {
                                $('.form_loop[data-question="we-require-a-full-body-shot-photo-of-you-either-standing-in-front-of-a-mirror-or-taken-by-someone-else-your-face-does-not-need-to-be-in-the-photo"]').addClass('d-none').removeClass('d-block');
                                $('.form_loop[data-question="please-provide-your-sex-at-birth-and-waist-circumference-in-centimetres"]').addClass('d-block');
                            } else {
                                $('.profile_upload_next').click();
                            }
                        }
                    }
                }
            });
        }
    }

    if (type == 'proof') {
        var file_type = $('#proof_file_type').val();
        if (file_type == 'upload_file' || file_type == 'screenshot') {
            var file_data = $('#Proof_Upload').prop('files')[0];
            var textareaval = $('#Proof_ScreenshotImage').val();
            var formDataToUpload = new FormData();
            formDataToUpload.append('file', file_data);
            formDataToUpload.append('screenshot', textareaval);
            formDataToUpload.append('file_type', file_type);
            formDataToUpload.append('type', type);

            $.ajax({
                url: url,
                type: "POST",
                contentType: false,
                processData: false,
                data: formDataToUpload,
                beforeSend: function() {
                    $('#upload_proof').attr('disabled', 'disabled');
                    $('#upload_proof').html('Please wait..');
                },
                success: function(result) {
                    var result = JSON.parse(result);
                    if (result.url != null) {
                        $('.proof_url_hidden').val(result.url);
                        $('#upload_proof').html('Done');
                        $('.proof_upload_next').click();
                    }
                }
            });
        }
    }
}
